import { slicedToArray as _slicedToArray } from '../_virtual/_rollupPluginBabelHelpers.js';
import { useCallback, useState, useEffect } from 'react';
import { isBrowser } from '../utils/dom.esm.js';

function useMedia(queries, values, defaultValue) {
  var match = useCallback(function () {
    var retVal = defaultValue;
    if (process.env.NODE_ENV !== 'test') {
      retVal = isBrowser ? values[queries.findIndex(function (q) {
        return window.matchMedia(q).matches;
      })] || defaultValue : defaultValue;
    }
    return retVal;
  }, [defaultValue, queries, values]);
  var _useState = useState(match),
    _useState2 = _slicedToArray(_useState, 2),
    value = _useState2[0],
    set = _useState2[1];
  useEffect(function () {
    var handler = function handler() {
      return set(match);
    };
    if (process.env.NODE_ENV !== 'test') {
      isBrowser && window.addEventListener('resize', handler);
    }
    return function () {
      if (process.env.NODE_ENV !== 'test') {
        isBrowser && window.removeEventListener('resize', handler);
      }
    };
  }, [match]);
  return value;
}

export default useMedia;
//# sourceMappingURL=use-media.esm.js.map
